const GSK_COLORS = {
    GSK_LIGHT_RED: "#FF585C",
    GSK_MEDIUM_RED: "#ED2736",
    GSK_DARK_RED: "#C7112D"
}

export default GSK_COLORS